import { Box, Chip } from '@material-ui/core';
import { ICellRendererParams } from 'ag-grid-community';
import { FieldsStatus } from 'api/file/interfaces/get-file-order-insights';
import { getChipProps, useStyles } from 'features/files/order-insights/components/StatusRow';
import { memo } from 'react';
import { OrderStatus } from './interfaces/partyList';

export default memo(function VerificationChip(params: ICellRendererParams<any, OrderStatus | undefined>) {
  const classes = useStyles();

  const status = params.value;
  if (!status) return null;

  const displayStatus =
    status.toLowerCase() === OrderStatus.USER_CANCELLED.toLowerCase() ? FieldsStatus.REQUEST_CANCELLED : status;
  const { icon, className } = getChipProps(displayStatus, classes, false, true);

  return (
    <Box className={classes.pdfValue}>
      <Chip label={displayStatus} className={`${className} ${classes.partyChips}`} icon={icon} size="small" />
    </Box>
  );
});
